<template>
  <div class="right_body">
    <search-box :fromData="fromData" @subSearch="subSearch"></search-box>
    <p style="height:45px;"></p>
    <tab-list
    :tabList="listArr"
    :total="total"
    :pages="pages"
    :fromData="fromData"
    :columns="tabColumns"
    tabName="system-monitor-log"
    @currentChange="currentChange"
    @changePages="changePages"
    @selectSdata="selectSdata">
    </tab-list>
  </div>
</template>
<script>
import tabList from 'components/table/list.vue';
import searchBox from './components/search.vue';
import {monitor} from 'api/system.js';
export default{
  components:{
    tabList,
    searchBox
  },
  data(){
    return{
      sdata:{},
      listArr:[],//列表
      tabColumns:[
        {field: 'account', title: '账号',need:true,width:120,"sortable":true},
        {field: 'username', title: '用户名',need:true,width:120,"sortable":true},
        {field: 'url', title: 'url'},
        {field: 'requestType', title: '请求类型',},
        {field:"executeTime",title:"执行耗时"},
        {field: 'operateTime', title: '操作时间'},
       /* {field: 'className', title: '处理类'},
        {field: 'methodName', title: '处理方法'}, */
        {field: 'methodName', title: '执行代码'},
        {field: 'clientIp', title: '客户端IP'},
        {field: 'browser', title: '浏览器'},
        {field: 'deviceName', title: '设备类型名'},
        {field: 'exceptionInfo', title: '异常消息'},
        {field: 'isException', title: '是否异常'},
        {field: 'methodInputParam1', title: '入参1'},
        {field: 'methodInputParam2', title: '入参2'},
        {field: 'methodOutputParam1', title: '出参1'},
        {field: 'methodOutputParam2', title: '出参2'},
        {field: 'operateTypeCode', title: '操作类型编码'},
        {field: 'operateTypeDesc', title: '操作类型描述'},
        {field: 'userAgent', title: '代理信息'}
      ],//表头字段
      total:0,//总条数
      pages:0,//总页数
      fromData:{
      	page:1,//当前页
      	pageSize:20,//每页显示的数量,
      	searchCriteria:{//查询的附加条件

      	},
      }
    }
  },
  created(){
    //设置默认日期最近一个月
    const startTime = new Date().getTime() - 3600 * 1000 * 24 * 30;
    const endTime = new Date();
    this.fromData.searchCriteria.startDate = this.$moment(startTime).format("YYYY-MM-DD");
    this.fromData.searchCriteria.endDate = this.$moment(endTime).format("YYYY-MM-DD");
    this.getList();
  },
  methods:{
    //获取列表
    async getList(){
    	let res = await this.$post(monitor.logList,this.fromData);
      if(res.status && res.data){
        this.pages = res.data.pages;
        this.listArr = res.data.list;
        this.total = res.data.total;
      }else{
        this.pages = 0;
        this.listArr = [];
        this.total = 0;
      }
    },
    //搜索
    subSearch(){
      this.getList();
      //console.log(1111);
    },
    //选中数据
    selectSdata(data){
      this.sdata = data;
    },
    //当前页码改变
    currentChange(currentPage){
    	this.fromData.page = currentPage;
    	this.getList();
    },
    //页码条数改变
    changePages(pages){
      this.fromData.page = 1;
      this.fromData.pageSize = pages;
      this.getList();
    }

  }

}
</script>

<style>
</style>
